import { useGateValue } from '@statsig/react-bindings';
import { useAiRecommendationData } from '@viome/viome-base/src/usecase/AiRecommendation/AiRecommendationQuery';
import { useUserDetails } from '@/hooks/useUserDetails';
import { useIsPatientContext } from '@/hooks/context/useContextStore';
import { isWrappedEligibleV2 } from '@/utils/isWrappedEligible';

export function useWrappedCardVisibility(): {
  visible: boolean;
  isLoading: boolean;
} {
  const userDetails = useUserDetails();
  // user_phi_id is on the runtime User payload but not yet in viome-base's
  // TypeScript model. See WrappedPageV2.tsx for the same cast.
  const userPhiId = (userDetails as unknown as { user_phi_id?: number })
    ?.user_phi_id;
  const { data: aiRecommendation, isLoading } =
    useAiRecommendationData(userPhiId);
  const wrappedFlagEnabled = useGateValue('enable-viome-wrapped');
  // Wrapped/Playbook is a consumer-FBI experience. AI-rec eligibility is
  // user-level (keyed by user_phi_id, not the active kit), so a user with a
  // released FBI consumer kit would otherwise see the card while viewing a
  // patient (e.g. pre-RnR PHPRO) context. Suppress it in patient context.
  const isPatientContext = useIsPatientContext();
  return {
    visible:
      !isPatientContext &&
      wrappedFlagEnabled &&
      isWrappedEligibleV2(aiRecommendation),
    isLoading,
  };
}
